var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M1.5 2.5h19a2 2 0 0 1 2 2v17h-19a2 2 0 0 1-2-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M3.5 2.5v10.704l2.127-1.914a2.5 2.5 0 1 1 4.745 0l1.593 1.434a2.5 2.5 0 0 1 1.402-.197l2.57-4.114a2.5 2.5 0 1 1 1.695 1.06l-2.57 4.114a2.5 2.5 0 1 1-4.435.623l-1.592-1.434A2.5 2.5 0 0 1 8 13a2.5 2.5 0 0 1-1.034-.223L3.5 15.894V19.5h19v2h-19a2 2 0 0 1-2-2v-17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M18 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M8 9.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
}))));
export default SvgIconGraph;